// Config per environment. Production/integration use same-origin API + WS.
const wsProtocol = () =>
  typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';

const hostWs = (path) => {
  if (typeof window === 'undefined' || !window.location || !window.location.host) {
    return path;
  }
  return wsProtocol() + '//' + window.location.host + path;
};

const config = {
  development: {
    API_BASE_URL: 'http://localhost',
    WS_BASE_URL: 'ws://localhost/api/v1/ws',
    WS_ENDPOINTS: {
      SYSTEM: '/system',
      CHAT: '/chat',
    },
  },
  production: {
    API_BASE_URL: '',
    WS_BASE_URL: hostWs('/api/v1/ws'),
    WS_ENDPOINTS: {
      SYSTEM: '/system',
      CHAT: '/chat',
    },
  },
  integration: {
    API_BASE_URL: '',
    WS_BASE_URL: hostWs('/api/v1/ws'),
    WS_ENDPOINTS: {
      SYSTEM: '/system',
      CHAT: '/chat',
    },
  },
};

const getEnvironment = () => {
  try {
    if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
      const env = process.env.NODE_ENV;
      if (config[env]) {
        return env;
      }
    }
  } catch (e) {
    // ignore
  }
  return 'development';
};

const environment = getEnvironment();

export const SYSTEM_USER_ID = '00000000-0000-0000-0000-000000000000';

export default config[environment] || config.development;
